import { api as userApi } from '@saucelabs/sl-module-user';
import { createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as actions from './actions';
import * as api from './api';
import { actions as jobActions } from './../filters';

export const fetchUser = createApiAction(
  types.USER_GET,
  async ({ username }) => {
    const { data: user } = await userApi.getUser({ username });

    if (user.team_management) {
      const { data: { results } } = await api.fetchUserServiceUserByUsername({ username });
      const userServiceUserId = results[0]?.id;

      if (!userServiceUserId) {
        return user;
      }

      const { data: userServiceUser } = await api.fetchUserServiceUser({ id: userServiceUserId });

      return {
        ...user,
        organization: userServiceUser.organization,
        teams: userServiceUser.teams,
        is_organization_admin: userServiceUser.is_organization_admin,
        is_team_admin: userServiceUser.is_team_admin,
      };
    }

    return user;
  },
);

export const putSubaccountUserInStore = (payload) => (dispatch) => {
  dispatch(actions.putUserInStore({
    ...payload,
    user_type: 'subaccount',
  }));
};

export const fetchOpenSauceUser = (payload) => (dispatch) => (
  // RESTo returns 403 response users's is_public flag is false
  // General axios middleware will cause an error page to show, no need for custom logic
  dispatch(actions.getRestoUser(payload))
    .then(({ data }) => (
      dispatch(actions.putUserInStore(data))
    ))
);

export const initialize = (payload) => (dispatch, getState) => (
  dispatch(fetchUser(payload, { skipErrorPage: true }))
    .then((user) => {
      const loggedUsername = getState().user.username;
      if (user.username !== loggedUsername) {
        dispatch(jobActions.updateOwnerFilter({
          type: 'user', name: user.username, label: user.username,
        }));
      }
      return dispatch(actions.initialize());
    })
);
